import React from "react";
import PropTypes from "prop-types";
import { Link, graphql, StaticQuery } from "gatsby";
import { kebabCase } from "lodash";

class StoreBrandListTemplate extends React.Component {
  render() {
    const { data } = this.props;
    const { edges: posts } = data.allMarkdownRemark;
    const { arg } = this.props;

    let brand = arg.brand;

    let list = [];
    let unique = [];

    posts.forEach(({ node: post }) => {
      if (post.frontmatter.product.brand === brand) {
        if (!unique[post.frontmatter.product.category]) {
          unique[post.frontmatter.product.category] = 1;
          list.push(
            <li key={`store___${kebabCase(post.frontmatter.product.category)}`}>
              <Link
                className="title has-text-primary is-size-4"
                to={`/store/${kebabCase(post.frontmatter.product.category)}/`}
              >
                {post.frontmatter.product.category}
              </Link>
            </li>
          );
        }
      }
    });
    if (list.length) {
      return (
        <>
          <div className="content">
            <h3>
              Product {list.length === 1 ? <>Category</> : <>Categories</>}:
            </h3>
            <ul className="no-bullets">{list}</ul>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="content">No products currently available.</div>
        </>
      );
    }
  }
}

StoreBrandList.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
};

export default function StoreBrandList(arg) {
  return (
    <StaticQuery
      query={graphql`
        query StoreBrandListQuery {
          allMarkdownRemark(
            sort: { frontmatter: { title: ASC } }
            filter: { frontmatter: { templateKey: { eq: "store-post" } } }
          ) {
            edges {
              node {
                id
                fields {
                  slug
                }
                frontmatter {
                  title
                  product {
                    brand
                    category
                    images {
                      image {
                        childImageSharp {
                          gatsbyImageData(
                            quality: 100
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `}
      render={(data, count) => (
        <StoreBrandListTemplate data={data} count={count} arg={arg} />
      )}
    />
  );
}
